import React from "react";
import { Form, Button } from "react-bootstrap";
import LoadingText from "../loader/LoadingText";
import LoadedText from "../loader/LoadedText";
import { useSelector } from "react-redux";

const UserProfileForm = ({
  title = "Confirm Your Profile Information",
  subtitle = "Make sure your profile information is correct.",
  userDetails,
  isFreshSocialSignin,
  errors,
  changePhoneErrorMsg,
  onChange,
  onSubmit,
  isSubmitting,
}) => {
  const userData = useSelector((state) => state?.user.profileInfo?.userDetails);

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Only digits, max 10
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]})-${match[2]}-${match[3]}`;
    }
    return cleaned;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!isFreshSocialSignin) {
      if (!userDetails.firstName?.trim()) {
        newErrors.firstName = "First name is required";
      }
      if (!userDetails.lastName?.trim()) {
        newErrors.lastName = "Last name is required";
      }
    }

    const phoneNumber = userDetails.phoneNumber || userData?.phoneNumber;
    if (!phoneNumber?.replace(/\D/g, "")) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (phoneNumber.replace(/\D/g, "").length !== 10) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      onSubmit(e);
    }
  };

  return (
    <div className="loginSignup-phoneVerification">
      <div className="registration-confirmProfile-headers">{title}</div>
      <div className="phn-verify-subheader">{subtitle}</div>

      {changePhoneErrorMsg?.length > 0 && (
        <p className="mt-4 error-ver text-danger">{changePhoneErrorMsg}</p>
      )}

      <div className="mt-4">
        <Form>
          {/* First Row - First Name & Last Name */}
          {!isFreshSocialSignin && (
            <div className="row mb-2 g-2">
              <div className="col-md-6 mb-md-0">
                <Form.Control
                  id="profile-firstname-input"
                  type="text"
                  placeholder="First Name"
                  name="firstName"
                  value={userDetails.firstName}
                  onChange={onChange}
                  isInvalid={!!errors.firstName}
                  className="loginSignUp-otherFields"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.firstName}
                </Form.Control.Feedback>
              </div>
              <div className="col-md-6">
                <Form.Control
                  id="profile-lastname-input"
                  type="text"
                  placeholder="Last Name"
                  name="lastName"
                  value={userDetails.lastName}
                  onChange={onChange}
                  isInvalid={!!errors.lastName}
                  className="loginSignUp-otherFields"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.lastName}
                </Form.Control.Feedback>
              </div>
            </div>
          )}

          {/* Second Row - Email (Disabled Field) */}
          {!isFreshSocialSignin && (
            <div className="col-12 mb-2">
              <Form.Control
                id="profile-email-input"
                type="email"
                placeholder="Email ID"
                value={userDetails.email}
                disabled
                className="loginSignUp-emailField"
              />
            </div>
          )}

          {/* Third Row - Mobile Number */}
          <div className="col-12 mb-2">
            <Form.Control
              id="profile-phone-input"
              type="tel"
              placeholder="Mobile Number"
              name="phoneNumber"
              value={
                userDetails.phoneNumber !== undefined
                  ? formatPhoneNumber(userDetails.phoneNumber)
                  : formatPhoneNumber(userData?.phoneNumber)
              }
              onChange={onChange}
              isInvalid={!!errors.phoneNumber}
              className="loginSignUp-otherFields"
              maxLength={10}
            />
            <Form.Control.Feedback type="invalid">
              {errors.phoneNumber}
            </Form.Control.Feedback>
          </div>

          {/* Submit Button */}
          <div className="row">
            <div className="col-12 text-center">
              <Button
                id="profile-save-continue-btn"
                type="button"
                onClick={handleSubmit}
                className="btn w-100 save-continue"
                style={{ fontFamily: "graphikregular" }}
              >
                {isSubmitting ? (
                  <LoadingText text="Saving..." />
                ) : (
                  <LoadedText text="Save & Continue" />
                )}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UserProfileForm;
